<div class="d-flex justify-content-center flex-wrap" style="margin-top: 1em">
    <p class="text-center m-3">
        <app-indian-currency-formatter class="highlight-amount" [amount]="investmentAmount - remainingAmount"
                                       [minimumFractionDigits]="0"></app-indian-currency-formatter>
        <br/>
        Amount already invested
    </p>
    <p class="text-center m-3">
        <app-indian-currency-formatter class="highlight-amount" [amount]="remainingAmount"
                                       [minimumFractionDigits]="0"></app-indian-currency-formatter>
        <br/>
        Amount pending to be auto invested
    </p>
</div>

<p class="remaining-amount-description">
    We will auto-invest the remaining amount of
    <app-indian-currency-formatter [amount]="remainingAmount"
                                   [minimumFractionDigits]="0"></app-indian-currency-formatter>
    based on your preference in new loans that get listed on finzy.
    <br/>
    We have multiple new loans listed everyday.
</p>